import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5de872f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "top-bar",
  class: "sticky-top bg-primary"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "overRun" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "m-0 text-light" }, "OverRun")
], -1))
const _hoisted_3 = { class: "text-light centered-text ms-2" }
const _hoisted_4 = {
  id: "top-side",
  class: "container-fluid p-0 m-0 shadow-sm"
}
const _hoisted_5 = { class: "row m-0 p-0 h-100" }
const _hoisted_6 = { class: "col h-100 text-start" }
const _hoisted_7 = {
  class: "text-light centered-text",
  id: "title"
}
const _hoisted_8 = { class: "col-7 m-0 p-0 h-100" }
const _hoisted_9 = {
  key: 0,
  id: "edition-button",
  class: "h-100 dropdown"
}
const _hoisted_10 = {
  id: "dropdownUserLink",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = { class: "centered-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-100 w-10",
  id: "edition-arrow"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "material-icons d-inline",
    id: "test"
  }, " expand_more ")
], -1))
const _hoisted_13 = {
  id: "dropdownUserMenu",
  class: "dropdown-menu p-0",
  "aria-labelledby": "dropdownUserLink"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item text-dark pt-0 pb-0",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon d-inline m-0 p-0" }, " settings "),
  /*#__PURE__*/_createElementVNode("p", { class: "d-inline" }, "Mon compte")
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider m-0 p-0" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item bg-danger text-light pt-0 pt-0",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon d-inline m-0 p-0" }, " meeting_room "),
  /*#__PURE__*/_createElementVNode("p", { class: "d-inline" }, "Déconnexion")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "top-logo",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.home && _ctx.home(...args)))
    }, [
      _hoisted_2,
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.editionName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.userButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("a", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.me.user?.username), 1)
                  ]),
                  _hoisted_12
                ]),
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.settings && _ctx.settings(...args)))
                  }, _hoisted_15),
                  _hoisted_16,
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args)))
                  }, _hoisted_18)
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_19
        ])
      ])
    ])
  ]))
}